import { Redirect, useLocalSearchParams } from "expo-router";

import { staffPath } from "../../../src/lib/hosting";
import { buildCentralCaseWorkspacePath } from "../../../src/lib/central-case-context";

export default function LegacyDirectorCaseRedirect() {
  const { caseId } = useLocalSearchParams<{ caseId?: string | string[] }>();
  const requestedCaseId = Array.isArray(caseId) ? caseId[0] ?? "" : caseId ?? "";

  return <Redirect href={staffPath(`/admin${buildCentralCaseWorkspacePath("case-overview", requestedCaseId)}`)} />;
}
